import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import LoginBG from '../assets/images/bg-admin.png';
import Logo from '../assets/images/logo.png';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState(['', '', '', '']);
  const [step, setStep] = useState(1);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const userStr = localStorage.getItem('user');
    let user = null;
    
    // Check if userStr exists and is not "undefined" or "null" string
    if (userStr && userStr !== 'undefined' && userStr !== 'null' && userStr.trim() !== '') {
      try {
        user = JSON.parse(userStr);
      } catch (e) {
        console.error('Error parsing user from localStorage:', e);
        localStorage.removeItem('user');
        user = null;
      }
    }

    if (accessToken && user) {
      axios.get(`${API_BASE_URL}/auth/validate`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
        .then(() => navigate('/'))
        .catch(() => {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('user');
        });
    }
  }, [API_BASE_URL, navigate]);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const handleSendOtp = async () => {
    try {
      setError('');
      const res = await axios.post(`${API_BASE_URL}/admin/login/request-otp`, { email });
      console.log('OTP Sent:', res.data);
      setStep(2);
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.message || 'Failed to send OTP');
    }
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleVerifyOtp = async () => {
    const fullOtp = otp.join('');
    if (fullOtp.length < 4) {
      setError('Enter all 4 digits');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/admin/login/verify-otp`, {
        email,
        otp: fullOtp
      });

      const { token, user } = response.data;

      localStorage.setItem('accessToken', token);
      localStorage.setItem('user', JSON.stringify(user));

      onLogin?.();
      navigate('/dashboard');
    } catch (err) {
      console.error('OTP Verification Failed:', err);
      setError(err?.response?.data?.message || 'Invalid OTP');
    }
  };

  return (
    <div>
      <div className='row'>
        <div className='col-6 align-items-center d-flex justify-content-center'>
          <img src={LoginBG} alt='bg' className='w-100' />
        </div>
        <div className='col-6'>
          <div className='w-75 bg-white rounded py-5 mt-5 pt-5 mx-auto mt-50-percent'>
            <div className='mt-5 pt-5 text-center'>
              <img src={Logo} alt="logo" className='mt-5 mb-4' width={100} height={100} />
              <h2 className='mb-4'>Junction Admin Login</h2>
            </div>

            {step === 1 ? (
              <div>
                <label className='pb-2'>Email</label>
                <input
                  className='form-control mb-3'
                  type="email"
                  placeholder='Enter your email'
                  autoComplete='off'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                {error && <div className='text-danger'>{error}</div>}
                <button className='btn btn-primary1 mt-3 px-5 py-3' onClick={handleSendOtp}>
                  Next
                </button>
              </div>
            ) : (
              <div className="text-center">
                <p>Enter the 4-digit OTP sent to <strong>{email}</strong></p>
                <div className="d-flex justify-content-center gap-2 mb-3">
                  {otp.map((digit, idx) => (
                    <input
                      key={idx}
                      id={`otp-${idx}`}
                      className="form-control text-center"
                      type="text"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleOtpChange(idx, e.target.value)}
                      style={{ width: '50px', fontSize: '24px' }}
                    />
                  ))}
                </div>
                {error && <div className='text-danger mb-2'>{error}</div>}
                <button className='btn btn-primary1 px-5 py-3' onClick={handleVerifyOtp}>
                  Verify & Login
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
